import { targetingTypes } from '../../../LineItemDv360Create/fields'

export const getIncludedAudiencesIds = targeting => {
  const audienceTargeting = targeting.find(item => item.type === targetingTypes.TARGETING_TYPE_AUDIENCE_GROUP)

  return (
    audienceTargeting?.included_first_and_third_party_audience_groups?.[0]?.settings?.map(
      item => item.firstAndThirdPartyAudienceId
    ) || []
  )
}

export const getExcludedAudiencesIds = targeting => {
  const audienceTargeting = targeting.find(item => item.type === targetingTypes.TARGETING_TYPE_AUDIENCE_GROUP)

  return (
    audienceTargeting?.excluded_first_and_third_party_audience_group?.settings?.map(
      item => item.firstAndThirdPartyAudienceId
    ) || []
  )
}

export const getCustomAudiences = (targeting, audiences) => {
  const includedAudiencesIds = getIncludedAudiencesIds(targeting)

  return audiences
    .filter(item => includedAudiencesIds.includes(item.id))
    .map(item => ({ ...item, value: item.id, label: item.name }))
}

export const getCustomAudiencesExclusion = (targeting, audiences) => {
  const excludedAudiencesIds = getExcludedAudiencesIds(targeting)

  return audiences
    .filter(item => excludedAudiencesIds.includes(item.id))
    .map(item => ({ ...item, value: item.id, label: item.name }))
}
